module.exports = __webpack_public_path__ + "img/1440.ec9c6208.jpg";